import React from 'react';
import {withFormsy} from 'formsy-react';
import PropTypes from 'prop-types';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import {SearchInput} from "./SearchInput";
import Component from "./../Component";

class MultiSelect extends Component {

    constructor(props) {
        super(props);

        this.state = {
            search: '',
            suggested: []
        }
    }

    onChange(option) {
        let value;
        if (TB.isArray(this.props.value)) {
            value = [...this.props.value];
            value = TB.xorBy(value, [option], 'id');
        }

        return this.props.onChange(value)
    }

    getOptions() {
        if (this.state.suggested?.length) {
            return this.state.suggested;
        }
        return this.props.options;
    }

    render() {

        return (
            <div className="filter-button-dropdown">
                <Dropdown isOpen={this.state.isEditing}
                          toggle={() => this.setState({isEditing: !this.state.isEditing})}>
                    <DropdownToggle caret tag="div" disabled={this.props.disabled}
                                    className="multi-select-button filter-button">
                        <span>
                            <span>{this.props.label}</span>
                            <span className={
                                TB.mapClass("filter-button-label", {
                                    active: (this.props.value || []).length > 0
                                })}>
                               {(this.props.value || []).length || "0"} Selected
                            </span>
                        </span>
                    </DropdownToggle>
                    <DropdownMenu className="filter-dropdown-menu" modifiers={{
                        setMaxHeight: {
                            enabled: true,
                            fn: (data) => {
                                return {
                                    ...data,
                                    styles: {
                                        ...data.styles,
                                        overflow: 'auto',
                                        maxHeight: '400px',
                                    },
                                };
                            },
                        },
                    }}>
                        <DropdownItem header>
                            <small className="text-bold flex-row flex-no-wrap flex">
                                <span className="text-bold mr-auto">
                                    {this.props.value.length || 'None'} Selected
                                </span>


                                {this.props.onReset && (<span className="ml-1 text-danger clickable px-2 text-uppercase"
                                       onClick={this.props.onReset}>
                                    Reset
                                </span>)}

                            </small>

                        </DropdownItem>
                        <DropdownItem divider/>

                        {this.props.searchEnabled && (
                            <DropdownItem tag={'div'} className="filter-search-input" toggle={false}
                                          key={TB.slugify(this.props.label) + '-search'}>
                                <SearchInput
                                    ref={this.SearchInputRef}
                                    value={this.state.search || ''}
                                    placeholder="Start typing to search.."
                                    onSearch={search => {
                                        if (search === '') {
                                            this.setState({search, suggested: []})
                                        } else this.setState({search})
                                    }}
                                    searchType={'skills'}
                                    valueLabelDisplay={'name'}
                                    onSuggestionsFetched={async (suggested) => {
                                        suggested = TB.map(suggested, option => ({...option, value: option.id}));

                                        this.promisedState({
                                            suggested,
                                            searchError: false
                                        })
                                    }}
                                    onLoading={async (searchLoading) => {
                                        clearTimeout(this.loadTimeout);
                                        if (searchLoading) {
                                            return this.promisedState({searchLoading, searchError: false});
                                        }
                                        await this.promisedState({searchError: false});

                                        this.loadTimeout = setTimeout(() => {
                                            return this.promisedState({searchLoading})
                                        }, 250)
                                    }}
                                    onError={async (searchError) => {
                                        clearTimeout(this.loadTimeout)
                                        await this.promisedState({
                                            searchError, suggested: [
                                                ...this.props.value
                                            ]
                                        });

                                        this.loadTimeout = setTimeout(() => {
                                            return this.promisedState({searchLoading: false})
                                        }, 250)
                                    }}
                                    disabled={this.props.disabled}
                                    name={TB.slugify(this.props.label) + '-search'}
                                />
                            </DropdownItem>
                        )}


                        {TB.map(this.getOptions() || [], (option, index) => {
                            let dropdownElements = [];
                            let displayValue = option.name || this.props.displayValue(option);

                            if (option.options) {
                                dropdownElements = TB.map(
                                    option.options,
                                    (cOption, cIndex) => {
                                        return this.renderOption(cOption, `${TB.slugify(index + cIndex)}`)
                                    }
                                )
                                dropdownElements.unshift((
                                    <DropdownItem header key={displayValue + '-header'}>
                                        {displayValue}
                                    </DropdownItem>
                                ))
                            } else {
                                dropdownElements = this.renderOption(option, index)
                            }

                            return dropdownElements;
                        })}
                        <DropdownItem divider/>
                        <DropdownItem header>
                            <small className="text-bold flex-row flex-no-wrap flex">

                        <span className="ml-auto text-dark clickable px-2 text-uppercase"
                              onClick={() => this.setState({isEditing: false})}>
                           Done
                        </span>

                            </small>

                        </DropdownItem>
                    </DropdownMenu>


                </Dropdown>

                <div className="help-text">
                    {this.props.formErrors && (
                        <p className="text-danger mb-0">
                            {this.props.formErrors}
                        </p>
                    )}
                </div>
            </div>
        );
    }

    renderOption(option, index) {
        let checked = TB.map(this.props.value, 'id').includes(option.id);

        let displayValue = option.name || this.props.displayValue(option);
        let disabled = option.disabled;
        const optionName = TB.slugify("filter" + displayValue + option.id);
        return (
            <DropdownItem
                tag="div" toggle={false}
                key={`option-${displayValue}-${index}`}
                className={TB.mapClass(
                    "filter-option-form",
                    {checked, disabled}
                )}>

                <div className={
                    TB.mapClass("form-checkbox", {
                        'disabled-checkbox': disabled
                    })
                }>
                    <input type="checkbox"
                           className="form-check-input"
                           name={optionName}
                           id={optionName}
                           required={false}
                           disabled={disabled}
                           onChange={() => this.onChange(option)}
                           checked={checked}/>

                    <label className="form-check-label" htmlFor={optionName}>
                        {this.props.displayValue?.(option) || option.name}
                    </label>

                </div>

            </DropdownItem>
        )
    }
}

MultiSelect.propTypes = {
    onChange: PropTypes.func,
    formErrors: PropTypes.any,
    options: PropTypes.any,
    disabled: PropTypes.any,
    searchEnabled: PropTypes.any,
    value: PropTypes.any,
};

const SelectInput = (props) => {


    return (
        <div className="form-group mb-0">
            <div className={TB.mapClass("form-checkbox", {
                "disabled-checkbox": props.disabled
            })}>

                <MultiSelect
                    {...props}
                    value={props.getValue() || []}
                    options={props.options}
                    label={props.label}
                    disabled={props.disabled}
                    onReset={props.onReset ? () => props.onReset([]) : undefined}
                    searchEnabled={props.searchEnabled}
                    onChange={async (items) => {
                        // if (TB.keys(this.state.formErrors).length) {
                        //     await this.promisedState({formErrors: null})
                        // }

                        return props.setValue(items || [])

                    }}
                />

            </div>
            {props.errorMessage && (
                <span className={'invalid-feedback'}>
                    {props.errorMessage}
                </span>
            )}
        </div>
    )
};


const MultiSelectInput = withFormsy(SelectInput);
export {MultiSelect};
export default MultiSelectInput;